export default __webpack_public_path__ + "static/media/645px-Love_Heart_SVG.svg.fd37c69a.png";